// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundPage_wrapper__t6xVV","title":"NotFoundPage_title__OJHfW","subtext":"NotFoundPage_subtext__kwZZb"};